import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        // Solid translucent white field
        "flex h-10 w-full rounded-lg border border-slate-200 bg-white/80 px-3 py-2 text-sm shadow-sm transition-all",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-slate-400",
        "focus-visible:outline-none focus-visible:border-indigo-400 focus-visible:ring-2 focus-visible:ring-indigo-200 focus-visible:bg-white",
        "hover:border-indigo-300/70",
        "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-slate-50",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
